enum CommentsActionType {
  INIT_STATE,
  RESET_STATE,
  SET_SELECTED_COMMENT_DIALOG_OPEN,
  GET_ALL_COMMENTS,
  GET_COMMENT,
  CREATE_COMMENT,
  UPDATE_COMMENT,
  SET_SELECTED_COMMENT,
  UPVOTE_COMMENT,
  DOWNVOTE_COMMENT,
  FLAG_COMMENT,
  DELETE_COMMENT,
  GET_ALL_REPLIES,
  GET_REPLY,
  CREATE_REPLY,
  UPDATE_REPLY,
  SET_SELECTED_REPLY,
  UPVOTE_REPLY,
  DOWNVOTE_REPLY,
  FLAG_REPLY,
  DELETE_REPLY,
}

export default CommentsActionType;
